import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatDialog, MatDialogRef } from '@angular/material';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { QueueService } from './queue.service';
import { VisitService } from '../visits/visit.service';
import { AuthenticationService } from '../shared/authentication.service';
import { parseErrors } from '../shared/api.service';
import { DataService } from '../shared/data.service';
import { SkipQueueDialogComponent } from './skip-queue-dialog.component';
import { Queue } from './queue';

@Component({
  selector: 'patient-queue',
  templateUrl: 'patient-queue.component.html',
  styleUrls: ['./patient-queue.component.scss'],
  providers: [AuthenticationService, QueueService, VisitService]
})

export class PatientQueueComponent implements OnInit, OnDestroy {
  loading = false;
  production = environment && environment.production;
  errors = [];
  skipTimer;
  user;
  data;
  status = false;
  subscription: Subscription;
  queueReq;
  patientReq;
  skipQueueReq;
  acceptVisitReq;
  queue;
  noPatients = false;
  tableData = new MatTableDataSource();
  displayedColumns: string[] = ['name', 'getPatient', 'waitTime', 'photo'];
  confirmDialog: MatDialogRef<any>;
  private patientsTimerSub;
  skipQueueCallback = () => {
    this.queue = null;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private queueService: QueueService,
    private visitService: VisitService,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.subscription = this.dataService.data$.subscribe(data => {
      this.data = data;
      this.status = this.data && this.data.status;
    });
    this.user = this.authenticationService.user();
    this.getPatients();

    this.patientsTimerSub = Observable.timer(1, 10000);
    this.patientsTimerSub.subscribe(t => {
      this.getPatients();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getPatients(query = {}) {
    if (this.queueReq) { this.queueReq.unsubscribe(); }
    this.queueReq = this.queueService.getQueues().subscribe(queues => {
      this.tableData.data = queues;
      if (this.tableData.data && this.tableData.data.length) {
        this.noPatients = false;
      } else {
        this.noPatients = true;
      }
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  getPatient(queue: Queue = null) {
    if (this.queueReq) { this.queueReq.unsubscribe(); }
    let queueServiceReq = this.queueService.getNextQueue();
    if (queue && queue.id) {
      queueServiceReq = this.queueService.getQueue(queue.id);
    }
    this.queueReq = queueServiceReq.subscribe(queue => {
      if (queue && queue.id) {
        this.queue = queue;
        this.queue.setSkipTimer();
      } else {
        this.queue = null;
        this.noPatients = true;
      }
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err)
    });
  };

  automaticallySkipQueue() {
    this.loading = true;
    if (this.skipQueueReq) { this.skipQueueReq.unsubscribe(); }
    this.skipQueueReq = this.queueService.skip(this.queue).subscribe(() => {
      this.queue = null;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  skipQueue(queue) {
    this.confirmDialog = this.dialog.open(SkipQueueDialogComponent, {
      width: '480px',
      height: '330px'
    });
    this.confirmDialog.componentInstance.callback = this.skipQueueCallback;
    this.confirmDialog.componentInstance.model = queue;
    this.confirmDialog.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        //
      }
      this.confirmDialog = null;
    });
  }

  acceptQueue(queue) {
    if (this.acceptVisitReq) { this.acceptVisitReq.unsubscribe(); }
    this.acceptVisitReq = this.visitService.accept(queue.visit).subscribe(visit => {
      this.queue = null;
      this.router.navigate(['/visits', visit.id]);
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  resetQueue(): void {
    this.loading = true;
    this.queueService.reset().subscribe(() => {
      this.queue = null;
      this.loading = false;
    }, err => {
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/patient-queue/patient-queue.component.ts